<script>
    import {
        Fancybox
    } from '@fancyapps/ui';
    import '@fancyapps/ui/dist/fancybox/fancybox.css';

    import {
        Thumbs
    } from '@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js';
    import '@fancyapps/ui/dist/carousel/carousel.thumbs.css';

    import {
        Carousel
    } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
    import "@fancyapps/ui/dist/carousel/carousel.css";

    export default {
        props: {
            options: Object,
            carouselOptions: Object
        },
        mounted() {
            Fancybox.bind(this.$refs.container, '[data-fancybox]', {
                ...(this.options || {}),
            });
            new Carousel(document.querySelector(".carousel-container"), {
                    infinite: false,
                    Dots: false,
                    Thumbs: {
                        type: 'classic',
                        Carousel: {
                            slidesPerPage: 1,
                            Navigation: true,
                            center: true,
                            fill: true,
                            dragFree: true,
                        },
                    },
                }, {
                    Thumbs
                });
        },
        updated() {
            Fancybox.unbind(this.$refs.container);
            Fancybox.close();

            Fancybox.bind(this.$refs.container, '[data-fancybox]', {
                ...(this.options || {}),
            });
        },
        unmounted() {
            Fancybox.destroy();
        },
    };

</script>

<template>
    <div ref="container">
        <div class="carousel-container">
            <slot></slot>
        </div>
    </div>
</template>

<style>
    .carousel-container,
    .f-thumbs.is-classic {
        --f-button-width: 40px;
        --f-button-height: 40px;
        --f-button-border-radius: 4px;

        --f-button-color: #ffffff;
        --f-button-hover-color: #ffffff;

        --f-button-bg: transparent;
        --f-button-hover-bg: transparent;
        --f-button-active-bg: transparent;

        --f-button-svg-width: 20px;
        --f-button-svg-height: 20px;
        --f-button-svg-stroke-width: 2.25;
        --f-button-svg-filter: none;

        --f-button-svg-disabled-opacity: 0.2;
    }

    .f-carousel__slide {
        display: flex;
        align-items: center;
        justify-items: center;
    }

    .carousel-container.f-carousel__nav {
        opacity: 0;
        transition: opacity 0.15s;
    }

    @media (hover: hover) {
        .carousel-container:hover .f-carousel__nav {
            opacity: 1;
        }
    }


    .fancybox__thumbs.is-classic.is-horizontal {
        --f-thumb-width: 75px;
        --f-thumb-height: 55px;
        --f-thumb-gap: 8px;
    }

    .fancybox__thumbs.is-classic.is-vertical {
        --f-thumb-width: 100%;
        --f-thumb-height: 100px;

        width: 182px;

        outline: 1px solid #edeef0;
    }

    .fancybox__thumbs.is-classic.is-vertical .f-thumbs__track {
        padding: 0 16px;
    }

    .fancybox__nav {
        --f-button-next-pos: 8px;
        --f-button-prev-pos: 8px;
    }

    .fancybox__slide {
        padding: 8px;
    }

</style>
